var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full h-full",attrs:{"id":_vm.getCanvasBoxId(_vm.cameraInfo.cameraIp, _vm.cameraInfo.cameraPort)}})}
var staticRenderFns = []

export { render, staticRenderFns }